module.exports = __webpack_public_path__ + "img/3db957f.png";